import { component } from "@tento-ui/component-decorators";
import { ChatTermTurn } from "../chat-term-turn";
import type { ChatMessage } from "../chat-types";

// Claude Code's dialect of the terminal register.
//
// A dialect is exactly one decision — which plugin renders a block — and
// `pluginTypeFor` is the seam the base register declares for it. Everything
// else (the one-metric enforcement, the gap vars, the height reporting, the
// recycle discipline) is inherited untouched, which is the point: the codex
// grammar and the Claude grammar are the same register speaking differently.
//
// The grammar, from Claude Code's own transcript:
//
//     ❯ add a dark-mode toggle and run the tests        (the banded prompt)
//     ⏺ I'll add the toggle, then run the suite.        (assistant prose)
//     ⏺ Bash(bun run build)                             (status-coloured dot)
//       ⎿  compiled 214 modules … +6 lines (ctrl+o to expand)
//
// The look's sheet grounds `std-chat-claude-turn[user]` for the full-width
// prompt band and states the palette; the plugins carry the captured
// component's colours as hook defaults.
@component({ name: "std-chat-claude-turn" })
export class ChatClaudeTurn extends ChatTermTurn {
  protected pluginTypeFor(blockType: string, message: ChatMessage): string {
    if (blockType === "tool_call") return "tool_call_claude";
    if (blockType === "text") {
      return message.role === "user" ? "prompt_claude" : "text_claude";
    }
    return blockType;
  }
}
